const id_trans_itemout = {
    "": "barang keluar",

    label: {
        number: "nomor barang keluar",
        sn_upload_text: "Unduh contoh file EXCEL upload Serial Number",
        select_doc: "Silahkan pilih dokumen yang akan dicetak...",
        btn_print_basic: "Cetak Dasar",
        btn_print_full: "Cetak Lengkap",
        label_storage: "nama label / lokasi penyimpanan"
    },

    error: {
        create: "Gagal membuat barang keluar",
        edit: "Gagal mengubah barang keluar",
        sn_over_qty: "Kuantitas melebihi total barang yang tersedia",
        sn_aviable: "Barang dengan serial number : {{sn}} telah keluar gudang atau belum terdaftar",
    },

    success: {
        create: "Berhasil membuat barang keluar",
        edit: "Berhasil mengubah barang keluar",
    },
}

export default id_trans_itemout;